module.exports = __webpack_public_path__ + "img/AFRUN.9b21109d.svg";